import API from "@/utils/api/index";
import { extractRegionsFromOffers } from './helpers.js';

export async function fetchVoucherOffers({ limit = 20, offset = 0, ...filters } = {}) {
  const params = new URLSearchParams();
  params.append('_limit', limit);
  params.append('_offset', offset);

  if (filters.brand) params.append('brand', filters.brand);
  if (filters.country) params.append('country', filters.country);
  if (filters.regions) params.append('regions', filters.regions);
  if (filters.subType) params.append('subType', filters.subType);
  if (filters.search) params.append('search', filters.search); // ✅ ADD THIS LINE

  const res = await API.get(`/vouchers/offers?${params.toString()}`);
  const data = res.data;

  const list = Array.isArray(data?.list) ? data.list : [];
  const total = Number.isInteger(data?.total) ? data.total : 0;

  return {
    list,
    total,
    limit,
    offset,
  };
}

export async function fetchVoucherBrandsMap() {
  try {
    const res = await API.get('/vouchers/brands'); // ✅ correct endpoint
    return res.data;
  } catch (err) {
    console.error('❌ Failed to fetch voucher brands map:', err.response?.data || err.message);
    return {};
  }
}

// 🆕 New helper:
export async function fetchVoucherRegions(filters = {}) {
  try {
    const offers = await fetchVoucherOffers(filters);
    return extractRegionsFromOffers(offers.list);
  } catch (err) {
    console.error('❌ Failed to fetch voucher regions:', err);
    return [];
  }
}

export async function purchaseVoucher(data) {
  const res = await API.post(`/transactions/voucher`, data);
  return res.data;
}
export async function fetchVoucherCountries() {
  try {
    const res = await API.get('/vouchers/countries'); // Your backend route
    return res.data; // Assumes array of { code }
  } catch (err) {
    console.error('❌ Failed to fetch voucher countries:', err.response?.data || err.message);
    throw err;
  }
}

export async function fetchVoucherFilterOptions(filters = {}) {
  try {
    const params = new URLSearchParams();

    if (filters.brand) params.append('brand', filters.brand);
    if (filters.country) params.append('country', filters.country);
    if (filters.subType) params.append('subType', filters.subType);
    if (filters.regions) params.append('regions', filters.regions);

    const res = await API.get(`/vouchers/filters?${params.toString()}`);
    return res.data; // { countries, subTypes, regions, brands }
  } catch (err) {
    console.error('❌ Failed to fetch filter options:', err.response?.data || err.message);
    return { countries: [], subTypes: [], regions: [], brands: [] };
  }
}
export async function fetchVoucherDetails(offerId) {
  if (!offerId) throw new Error('Missing offerId');

  try {
    const res = await API.get(`/vouchers/offers/${offerId}`);
    return res.data; // Full offer detail from backend (cached if available)
  } catch (err) {
    console.error(`❌ Failed to fetch voucher details for ${offerId}:`, err.response?.data || err.message);
    throw err;
  }
}
